import React from 'react';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { styled } from '@mui/material/styles';

const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'isHovered',
})(({ theme, isSelected, isHovered, day }) => ({
    "borderRadius": 0,
    '&.MuiPickersDay-dayOutsideMonth': {
        "color": theme.palette.text.disabled,
    },
    ...(isSelected && {
        '&.MuiPickersDay-root.Mui-disabled': {
            "color": theme.palette.primary.contrastText,
        },
        "backgroundColor": theme.palette.primary.main,
        "color": theme.palette.primary.contrastText,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.main,
        },
    }),
    ...(isHovered && {
        '&.MuiPickersDay-root.Mui-disabled': {
            "color": theme.palette.primary.contrastText,
        },
        "backgroundColor": theme.palette.primary[theme.palette.mode],
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary[theme.palette.mode],
        },
    }),

}));

export const Day = (props) => {
    const { startDate, endDate, day, ...other } = props;
    let isSelected = day.isBetween(startDate, endDate, 'day', '[]');
    let isHovered = day.isBetween(startDate, endDate, 'day', '()');
    return (
        <CustomPickersDay
            isSelected={isSelected}
            isHovered={isHovered}
            day={day}
            {...other}
        />
    );
};